<template>
  <div>
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="绑定设备充值订单" name="0"></el-tab-pane>
      <el-tab-pane label="区域设备充值订单" name="1" v-if="level === 'AREA'"></el-tab-pane>
    </el-tabs> -->
    <com-search :columns="searchColumn" @search="handleSearch"></com-search>
    <div class="mb-15px flex justify-end">
      <el-button type="primary" @click="handleExport" :disabled="isExporting" :loading="isExporting">导出</el-button>
    </div>
    <com-table ref="table" :defaultParams="{ code }" :columns="columns" :api="api">
      <template #createTime="row">
        {{ row.data.createTime | timeFormate }}
      </template>
    </com-table>
  </div>
</template>

<script>
import { partnerRechargeOrder, partnerXdWalletTxFlowExport } from '@/api/partners'
import { downloadFile } from '@/utils/download'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // defaultParams: {},
      activeName: '0',
      api: partnerRechargeOrder,
      exportQuery: {},
      isExporting: false,
      columns: [
        {
          label: '订单编号',
          prop: 'number',
          width: 170
        },
        {
          label: '流水号',
          prop: 'transactionId',
          width: 280
        },
        {
          label: '用户ID',
          prop: 'userNum',
          minWidth: 120
        },
        {
          label: '手机号',
          prop: 'phone',
          minWidth: 120
        },
        {
          label: '充值金额',
          prop: 'paySum'
        },
        {
          label: '订单分成',
          prop: 'orderDivide'
        },
        {
          label: '充值类型',
          prop: 'type'
        },
        {
          label: '充值时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '180'
        }
      ],
      searchColumn: [
        {
          label: '用户ID/手机号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '订单编号',
          prop: 'orderNum',
          type: 'input'
        },
        {
          label: '充值时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      // if (this.activeName === '1') {
      //   this.defaultParams.areaPartnerCode = this.code
      //   delete this.defaultParams.partnerCode
      //   this.$refs.table.init()
      //   return
      // }

      // this.defaultParams.partnerCode = this.code
      // delete this.defaultParams.areaPartnerCode
      this.$refs.table.init()
    },
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.table.search(val)
    },
    handleExport() {
      if (!this.code) {
        this.$message.error('合伙人编码不能为空')
        return
      }

      if (this.isExporting) {
        this.$message.warning('正在导出中，请勿重复点击')
        return
      }

      this.isExporting = true
      this.$message.info('请稍等,正在导出...')

      const params = {
        code: this.code,
        ...this.exportQuery
      }

      partnerXdWalletTxFlowExport(params)
        .then((blob) => {
          downloadFile(blob, `充值订单_${new Date().getTime()}.xlsx`)
          this.$message.success('导出成功')
        })
        .catch((error) => {
          console.error('导出失败:', error)
        })
        .finally(() => {
          this.isExporting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
